<template>
    
        <div
            class="app-card text--text"
            :width="width"
            :min-width="minWidth"
            :min-height="minHeight"
        >

            <div @click="$emit('click')">
                <div 
                    v-if="!hideHeader" 
                    class="app-card-header"
                >
	                <div style="display: flex; align-items: center">
		                <div style="font-size: 18px">
			                {{ title }}
		                </div>
		
		                <v-spacer></v-spacer>
		                <v-btn v-if="editable" icon variant="text" size="small" @click.stop="$emit('edit')" style="color: white;">
			                <v-icon>mdi-pencil</v-icon>
		                </v-btn>
		                <slot name="header-right"></slot>
	                </div>
                    
	                <slot name="header-bottom"></slot>
                </div>
            <slot></slot>
            </div>
        </div>
    
    
</template>

<script>
export default {
    name: "AppCard",
    props: {
        width: {
            type: Number
        },
        minWidth: {
            type: Number
        },
        minHeight: {
            type: Number
        },
        hideHeader: {
            type: Boolean,
            default: false
        },
        title: {
            default: 'Title'
        },
        editable: {
            type: Boolean
        }
    }
}
</script>

<style scoped>
.v-card {
    overflow: hidden;
}

.app-card {
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
    border: 1px solid #E5E7EB;
    background-color: white;
    transition: box-shadow 0.2s ease;
}

.app-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.app-card-header {
    width: 100%;
    border-bottom: 1px solid #E5E7EB;
    background-color: #33D3FF;
    color: white;
    padding: 14px 16px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
}
</style>